import { isAppHandoffCallbackUrl, parseHandoffTokenFromUrl } from '@/lib/auth/app-handoff';
import { isOAuthCallbackUrl, processOAuthCallbackUrl } from '@/lib/oauth/google-oauth';
import { useAuthStore } from '@/store/authStore';
import * as Linking from 'expo-linking';
import { useEffect } from 'react';
import { Platform } from 'react-native';

/**
 * Completa OAuth quando o deep link chega fora do WebBrowser.openAuthSessionAsync.
 */
export function useOAuthDeepLink() {
  const loginWithOAuthToken = useAuthStore((state) => state.loginWithOAuthToken);
  const loginWithHandoff = useAuthStore((state) => state.loginWithHandoff);
  const linkingUrl = Linking.useLinkingURL();

  useEffect(() => {
    if (Platform.OS === 'web' || !linkingUrl) {
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        if (isAppHandoffCallbackUrl(linkingUrl)) {
          const handoff = parseHandoffTokenFromUrl(linkingUrl);
          if (!cancelled && handoff) {
            await loginWithHandoff(handoff);
          }
          return;
        }

        if (!isOAuthCallbackUrl(linkingUrl)) {
          return;
        }

        const session = await processOAuthCallbackUrl(linkingUrl);
        if (!cancelled && session?.access_token) {
          await loginWithOAuthToken(session.access_token);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('OAuth deep link error:', error);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [linkingUrl, loginWithOAuthToken, loginWithHandoff]);
}
